import * as React from "react";
const SvgDiners = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "37px", height: "24px", viewBox: "0 0 37 24", ...props }, /* @__PURE__ */ React.createElement("g", { id: "surface1" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 37, height: 24, style: {
  fill: "rgb(0%,47.450981%,74.509805%)",
  fillOpacity: 1,
  stroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 28.457031 12.070312 C 28.457031 7.296875 24.523438 4 20.210938 4 L 16.496094 4 C 12.132812 4 8.542969 7.296875 8.542969 12.070312 C 8.542969 16.433594 12.132812 20.019531 16.496094 20 L 20.210938 20 C 24.523438 20.019531 28.457031 16.433594 28.457031 12.070312 Z M 28.457031 12.070312 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(0%,47.450981%,74.509805%)",
  fillOpacity: 1
}, d: "M 16.519531 4.675781 C 12.53125 4.679688 9.300781 7.957031 9.300781 12 C 9.300781 16.042969 12.535156 19.320312 16.519531 19.324219 C 20.511719 19.320312 23.742188 16.042969 23.742188 12 C 23.742188 7.957031 20.511719 4.679688 16.519531 4.675781 Z M 16.519531 4.675781 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 11.957031 11.980469 C 11.960938 10.003906 13.179688 8.320312 14.894531 7.648438 L 14.894531 16.3125 C 13.179688 15.640625 11.960938 13.957031 11.957031 11.980469 Z M 18.171875 16.3125 L 18.171875 7.648438 C 19.890625 8.316406 21.109375 10.003906 21.109375 11.980469 C 21.109375 13.960938 19.890625 15.644531 18.171875 16.3125 Z M 18.171875 16.3125 " })));
export default SvgDiners;
